import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Container, Typography, Box, Button } from "@mui/material";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";

import styles from "./AboutUs.module.scss";
import { axiosInstance } from "../../services";
import { slugify } from "../../utils";
import { Loader } from "../../library/common";
import MetaTag from "../../library/meta";
import localesKeys from "../../locales/localesKeys.json";

const AboutUs = () => {
  const { t } = useTranslation();

  const [showVideo, setShowVideo] = useState(false);
  const [list, setList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const {
    i18n: { language },
  } = useTranslation();

  useEffect(() => {
    axiosInstance
      .get("/aboutus")
      .then((res) => {
        if (res?.data?.length) {
          setList(res?.data?.sort((a, b) => (a.order < b.order ? -1 : 1)));
        }
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  }, []);

  useEffect(() => {
    if (location.hash && list?.length) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);
  return (
    <Container maxWidth={true} className={styles.aboutContainer}>
      <MetaTag url="/about" title={t(localesKeys.NAVIGATION_ABOUT)} />
      {list?.map(({ heading, description, isImage, cardImage }, i) => (
        <Box
          id={`${slugify(heading?.[language])}`}
          className={
            styles.section + " " + (i % 2 === 1 ? styles.reverseContainer : "")
          }
          key={i}
        >
          <Box className={styles.contentLeft}>
            <Typography variant="h2" className={styles.sectionTitle}>
              {heading?.[language] ? heading?.[language] : ""}
            </Typography>
            <Typography className={styles.sectionText}>
              {description?.[language] ? description?.[language] : ""}
            </Typography>
          </Box>
          <Box className={styles.contentLeft}>
            {isImage ? (
              <Box className={styles.imageWrapper}>
                <LazyLoadImage
                  effect="blur"
                  src={cardImage}
                  alt={heading?.[language] ? heading?.[language] : ""}
                  className={styles.missionImage}
                />
              </Box>
            ) : (
              <Box className={styles.videoWrapper}>
                <Box className={styles.videoPlaceholder}>
                  {!showVideo ? (
                    <Button
                      className={styles.playButton}
                      startIcon={<PlayCircleIcon className={styles.playIcon} />}
                      onClick={() => setShowVideo(true)}
                    >
                      Play Video
                    </Button>
                  ) : (
                    <iframe
                      width="100%"
                      height="100%"
                      src={cardImage}
                      title={heading}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        borderRadius: "16px",
                      }}
                    />
                  )}
                </Box>
              </Box>
            )}
          </Box>
        </Box>
      ))}

      {isLoading && <Loader />}
    </Container>
  );
};

export default AboutUs;
